// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {actionsRolesAllow} from './ActionsRolesAllow';
import type {RoleDescriptionProps} from './RoleDescription';

const opalViewOnlyRoleMessages = defineMessages({
  roleName: {
    id: 'docsApp.components.contrib.roleDescriptions.opalViewOnlyRole.roleName',
    description: 'The name of the Opal view only role.',
    defaultMessage: 'Opal View Only',
  },
  descriptionOfWhatRoleCanDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.opalViewOnlyRole.descriptionOfWhatRoleCanDo',
    description: 'The description of what the Opal view only role can do.',
    defaultMessage:
      'This role gives employees access to sensitive financial information. Accountants or bookkeepers might find this role useful.',
  },
  descriptionOfWhatRoleCannotDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.opalViewOnlyRole.descriptionOfWhatRoleCannotDo',
    description: "The description of what the Opal view only role can't do.",
    defaultMessage:
      "They can't send or add money, order cards for team members, or manage payouts.",
  },
});

const opalRoleDescriptionProps: RoleDescriptionProps = {
  roleName: <FormattedMessage {...opalViewOnlyRoleMessages.roleName} />,
  roleExternalId: 'opal_view_only',
  isBeta: true,
  descriptionOfWhatRoleCanDo: (
    <FormattedMessage
      {...opalViewOnlyRoleMessages.descriptionOfWhatRoleCanDo}
    />
  ),
  descriptionOfWhatRoleCannotDo: (
    <FormattedMessage
      {...opalViewOnlyRoleMessages.descriptionOfWhatRoleCannotDo}
    />
  ),
  someThingsThisRoleCanDo: [
    <FormattedMessage {...actionsRolesAllow.viewTransactions} />,
    <FormattedMessage {...actionsRolesAllow.viewStatements} />,
    <FormattedMessage {...actionsRolesAllow.viewTransfers} />,
    <FormattedMessage {...actionsRolesAllow.viewBalance} />,
    <FormattedMessage {...actionsRolesAllow.viewPayments} />,
    <FormattedMessage {...actionsRolesAllow.viewPayouts} />,
  ],
  someThingsThisRoleCannotDo: [
    <FormattedMessage {...actionsRolesAllow.createOutboundPayments} />,
    <FormattedMessage {...actionsRolesAllow.addFunds} />,
    <FormattedMessage
      {...actionsRolesAllow.transferBalanceAndReverseTransfers}
    />,
    <FormattedMessage
      {...actionsRolesAllow.payoutBalanceToExternalBankAccount}
    />,
    <FormattedMessage {...actionsRolesAllow.addAndEditBankAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.createRefundPayments} />,
    <FormattedMessage {...actionsRolesAllow.addEditRemoveTeamMembers} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteProducts} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteCustomers} />,
    <FormattedMessage {...actionsRolesAllow.resolveDisputes} />,
  ],
};

export const allOpalRoleProps = [opalRoleDescriptionProps];
